import * as html from 'smg/html';

function targetElements($target: HTMLElement) {
    if (!($target instanceof HTMLElement && $target.matches('.btn')) || $target.matches('.btn-check + .btn') || $target.matches('.btn-group > .btn') || $target.matches('.btn.rounded-circle')) {
        return;
    }

    return $target;
}

function createBtnBorder($target: HTMLElement) {
    let color1 = '#2b4db2';
    let color2 = '#26449d';

    if ($target.matches('[data-bs-theme=blue] *')) {
        color1 = '#e1f8fd';
        color2 = '#d0f5fc';
    }

    const outlineSVG = `<svg
        version="1.1"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:svg="http://www.w3.org/2000/svg">
        <defs id="defs2">
            <linearGradient id="linearGradient1320">
            <stop style="stop-color:${color1};stop-opacity:1" offset="0" />
            <stop style="stop-color:${color2};stop-opacity:1" offset="1" />
            </linearGradient>
            <linearGradient
            xlink:href="#linearGradient1320"
            id="linearGradient1322"
            gradientUnits="userSpaceOnUse" />
        </defs>
        <rect id="outline" style="fill:none;stroke:url(#linearGradient1322);stroke-linecap:butt;stroke-linejoin:round;stroke-miterlimit:0;stroke-dasharray:none;stroke-opacity:1;stop-color:#000000" />
        </svg>`;

    const $border = html.FromString(`<div>${outlineSVG}</div>`);
    $border.className = 'btn-focus-outline';

    const $svg = $border.querySelector('svg') as SVGSVGElement;
    const $rect = $border.querySelector('#outline') as SVGRectElement;
    const $gradient = $border.querySelector('#linearGradient1322') as SVGLinearGradientElement;

    const draw = () => {
        const outlineWidth = parseFloat('3');
        let padding = parseFloat('3');
        let radius = '50%';

        if ($target.matches('#footer-links-mobile .btn.footer-dropdown-toggle')) {
            padding = 0;
        }

        if ($target.matches('.btn-link')) {
            padding = 0;
            radius = '1rem';
        }

        $rect.setAttribute('ry', radius);
        $rect.style.strokeWidth = String(outlineWidth);

        const { width, height } = $target.getBoundingClientRect();

        const svgWidth = width + (outlineWidth + padding) * 2;
        const svgHeight = height + (outlineWidth + padding) * 2;

        $svg.setAttribute('viewBox', `0 0 ${svgWidth} ${svgHeight}`);
        $svg.setAttribute('width', String(svgWidth));
        $svg.setAttribute('height', String(svgHeight));

        $rect.setAttribute('width', String(width + outlineWidth + (padding * 2)));
        $rect.setAttribute('height', String(height + outlineWidth + (padding * 2)));
        $rect.setAttribute('x', String(outlineWidth / 2));
        $rect.setAttribute('y', String(outlineWidth / 2));

        $gradient.setAttribute('x1', String(0));
        $gradient.setAttribute('y1', String(0));
        $gradient.setAttribute('x2', String(width));
        $gradient.setAttribute('y2', String(height));

        $border.style.top = `${$target.offsetTop - outlineWidth - padding}px`;
        $border.style.left = `${$target.offsetLeft - outlineWidth - padding}px`;
    };
    draw();

    let cancel = false;
    const sizeAndPosition = { width: $target.offsetWidth, height: $target.offsetHeight, top: $target.offsetTop, left: $target.offsetLeft };
    const checkSizeAndPosition = () => {
        if (cancel) {
            return;
        }
        if (sizeAndPosition.width !== $target.offsetWidth ||
            sizeAndPosition.height !== $target.offsetHeight ||
            sizeAndPosition.top !== $target.offsetTop ||
            sizeAndPosition.left !== $target.offsetLeft) {
            // update the size and position of the border
            sizeAndPosition.width = $target.offsetWidth;
            sizeAndPosition.height = $target.offsetHeight;
            sizeAndPosition.top = $target.offsetTop;
            sizeAndPosition.left = $target.offsetLeft;
            draw();
        }
        window.requestAnimationFrame(checkSizeAndPosition);
    };
    window.requestAnimationFrame(checkSizeAndPosition);

    $target.parentElement?.appendChild($border);

    setTimeout(() => $border.style.opacity = '1');

    const fadeOutTimeout = getComputedStyle(document.body).getPropertyValue('--smg-focus-ring-animation-speed');

    const removeBorder = () => {
        $border.style.opacity = '0';
        setTimeout(() => {
            $border.remove();
            cancel = true;
        }, parseFloat(fadeOutTimeout) * 1000);
    };

    return removeBorder;
}

document.addEventListener('focus', e => {
    const $target = targetElements(e.target as HTMLElement) || undefined;
    if (!$target) {
        return;
    }

    if ($target.matches(':disabled') || $target.matches('.is-invalid') || !$target.matches(':focus-visible')) {
        return;
    }

    const removeBorder = createBtnBorder($target);
    const removeBorderAndListeners = () => {
        removeBorder();
        $target?.removeEventListener('blur', removeBorderAndListeners);
    };

    $target?.addEventListener('blur', removeBorderAndListeners);
}, true);

export function CustomQtyBtnInit($container: HTMLElement) {
    if (!$container?.classList.contains('custom-qty-input')) {
        return;
    }

    const $input = $container.querySelector<HTMLInputElement>('input');
    const $decreaseBtn = $container.querySelector<HTMLButtonElement>('.decrement');
    const $increaseBtn = $container.querySelector<HTMLButtonElement>('.increment');

    for (const $btn of [$decreaseBtn, $increaseBtn]) {
        $btn?.addEventListener('click', () => {
            if (!$input) {
                return;
            }

            const value = parseInt($input.value, 10);

            if ($btn === $decreaseBtn) {
                if (value > 1) {
                    $input.value = String(value - 1);
                    $input.dispatchEvent(new Event('change'));
                }
            } else {
                $input.value = String(value + 1);
                $input.dispatchEvent(new Event('change'));
            }
        });
    }
}